import { Component } from '@angular/core';
import { EntitlementsService } from '../../entitlements/entitlements.service';
import { ES5ZoneAwareRouter } from '../../elements-routing/es5ZoneAwareRouter';
import { FeatureToggleService } from '../../shared/services/feature-toggle/feature-toggle.service';

@Component({
  selector: 'ssg-quick-actions',
  templateUrl: './quick-actions.component.html',
  styleUrls: ['./quick-actions.component.less']
})
export class QuickActionsComponent {
  constructor(
    private readonly router: ES5ZoneAwareRouter,  // For IE support only, when we no longer support IE change this to Router.
    private readonly entitlementsService: EntitlementsService,
    private readonly featureToggleService: FeatureToggleService,
  ) { }

  get showPayCustomerInfos() {
    return this.entitlementsService.isEntitled(['ViewPayCustomerInfos']);
  }

  viewPays() {
    this.router.navigate([{outlets: { eepay: 'payinfo'}}]);
  }

  get showStaleDatedChecks() {
    return this.featureToggleService.isFeatureEnabled('enableStaleDatedChecks')
        && this.entitlementsService.isEntitled(['ViewStaleDatedChecksInfos']);
  }

  get showSendPrenoteFile() {
    return this.featureToggleService.isFeatureEnabled('enableSendPrenoteFile')
        && this.entitlementsService.isEntitled(['PsgViewCompanies']);
  }

  viewStaleDatedChecks() {
    this.router.navigate([{outlets: { eepay: 'staledatedchecksinfo'}}]);
  }

  viewCompanies() {
    this.router.navigate([{outlets: { eepay: 'viewcompanies'}}]);
  }
}
